module.exports = __webpack_public_path__ + "img/sunrise_4.c2a97e49.png";